module.exports = __webpack_public_path__ + "static/media/dashboardActive.bd60596b.svg";